document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const menu = event.target.closest('.mobile-menu');
  document.querySelectorAll('.mobile-menu[open]').forEach((item) => {
    if (item !== menu) item.removeAttribute('open');
  });
});

document.addEventListener('shopify:section:load', () => {
  document.documentElement.classList.remove('no-js');
  initLgeCatalog();
});

const LGE_CATEGORIES = {
  'tires': {
    number: '01', title: 'Tires', eyebrow: 'ROAD · COMMERCIAL · SPECIALTY', headline: 'Performance built for every road.',
    intro: 'A broad tire sourcing portfolio for passenger, commercial, motorcycle, off-road and agricultural markets—matched to your sizes, application and destination requirements.',
    assurance: ['Multiple applications', 'Mixed-size planning', 'Factory comparison'],
    subcategories: [['passenger-cars','Passenger Cars'],['suv-light-trucks','SUV & Light Trucks'],['trucks-buses','Trucks & Buses'],['off-the-road','Off The Road'],['agriculture','Agriculture'],['motorcycle','Motorcycle'],['tire-changer','Tire Changer']]
  },
  'wheel': {
    number: '02', title: 'Wheel', eyebrow: 'FITMENT · FINISH · PERFORMANCE', headline: 'Engineered fit. Distinctive finish.',
    intro: 'Source cast, forged, flow-formed, truck and motorcycle wheel options with coordinated specifications, finish confirmation and export support.',
    assurance: ['Application matching', 'Finish options', 'Mixed-model orders'],
    subcategories: [['low-pressure','Low Pressure'],['forged','Forged'],['flow-forming','Flow Forming'],['scooter','Scooter'],['motorcycle-wheel','Motorcycle Wheel'],['truck-wheel','Truck Wheel']]
  },
  'batteries': {
    number: '03', title: 'Batteries', eyebrow: 'AUTOMOTIVE · INDUSTRIAL · ENERGY', headline: 'Reliable power for every application.',
    intro: 'Automotive, VRLA, lithium, motive and industrial battery solutions supported by clear specification matching and shipment coordination.',
    assurance: ['Specification control', 'Application guidance', 'Packing coordination'],
    subcategories: [['maintenance-free-battery','Maintenance-Free Battery'],['start-stop-battery','Start Stop Battery'],['dry-charged-battery','Dry Charged Battery'],['power-wall','Power Wall'],['forklift-battery','Forklift Battery'],['lithium-battery','Lithium Battery'],['vrla-battery','VRLA Battery'],['ev-evf-battery','EV / EVF Battery'],['battery-pole','Battery Pole']]
  },
  'car-accessories': {
    number: '04', title: 'Car Accessories', eyebrow: 'COMFORT · UTILITY · EVERYDAY VALUE', headline: 'Accessories made for real markets.',
    intro: 'Build a practical car accessories assortment across protection, comfort, convenience and in-vehicle use, with flexible mixed-product purchasing.',
    assurance: ['Retail-ready ranges', 'Flexible quantities', 'Packaging options'],
    subcategories: [['exterior-accessories','Exterior Accessories'],['car-phone-holder','Car Phone Holder']]
  },
  'auto-tools': {
    number: '05', title: 'Auto Tools', eyebrow: 'WORKSHOP · REPAIR · EQUIPMENT', headline: 'Workshop equipment that works harder.',
    intro: 'Professional jacks, wheel and tyre tools, disassembly equipment and workshop solutions for distributors, garages and service networks.',
    assurance: ['Workshop applications', 'Technical matching', 'Commercial sourcing'],
    subcategories: [['jack','Jack'],['brake-pad-disassembly-tool','Brake Pad Disassembly Tool'],['oil-filter-disassembly-tool','Oil Filter Disassembly Tool'],['wheel-tyre-tool','Wheel & Tyre Tool'],['power-tools','Power Tools']]
  },
  'car-care': {
    number: '06', title: 'Car Care', eyebrow: 'CLEAN · PROTECT · MAINTAIN', headline: 'Professional care from interior to finish.',
    intro: 'Car cleaning, maintenance, lubricants and film products sourced for retail, workshop and distribution channels.',
    assurance: ['Complete care ranges', 'Private label options', 'Mixed-product loading'],
    subcategories: [['car-interior-clean','Car Interior Clean'],['car-exterior-clean','Car Exterior Clean'],['lubricant','Lubricant'],['automotive-film','Automotive Film']]
  },
  'car-parts': {
    number: '07', title: 'Car Parts', eyebrow: 'BRAKING · LIGHTING · REPLACEMENT', headline: 'Parts that keep business moving.',
    intro: 'A practical replacement-parts portfolio spanning brake systems, lighting, filters, ignition and everyday service items for global buyers.',
    assurance: ['Application matching', 'Supplier comparison', 'Quality coordination'],
    subcategories: [['brake-system','Brake System'],['car-led-light','Car LED Light'],['spark-plug','Spark Plug'],['auto-spare-parts','Auto Spare Parts'],['fuel-injector','Fuel Injector'],['gasket-kit','Gasket Kit'],['car-bumper','Car Bumper'],['oil-filter','Oil Filter'],['air-filter','Air Filter'],['wiper-blades','Wiper Blades']]
  },
  'sourcing': {
    number: '08', title: 'Sourcing', eyebrow: 'ONE PARTNER · MORE POSSIBILITIES', headline: 'Beyond automotive. Built around your market.',
    intro: 'Use our sourcing network for furniture, home appliances, electronics, bicycles, sports products, kitchenware and other commercial requirements.',
    assurance: ['Cross-category sourcing', 'Factory negotiation', 'One consolidated shipment'],
    subcategories: [['bed','Bed'],['sofa-chair','Sofa / Chair'],['patio-furniture','Patio Furniture'],['furniture','Furniture'],['office-furniture','Office Furniture'],['outdoor-furniture','Outdoor Furniture'],['home-appliance','Home Appliance'],['electronics','Electronics'],['bicycle','Bicycle'],['sports','Sports'],['kitchenware-products','Kitchenware Products'],['household-items','Household Items'],['other','Other']]
  },
  'electric-vehicle': {
    number: '09', title: 'Electric Vehicle', eyebrow: 'NEW ENERGY · CHINA SUPPLY', headline: 'China’s EV brands, ready for global markets.',
    intro: 'Explore selected electric vehicle brands and commercial models with sourcing, specification confirmation and export coordination from China.',
    assurance: ['Brand collections', 'Model confirmation', 'Export coordination'],
    subcategories: [['dongfeng-forthing','DONGFENG FORTHING'],['gac-aion','GAC Aion'],['byd','BYD'],['foton','Foton'],['saic-wuling','SAIC Wuling']]
  }
};

function lgeEscapeHtml(value) {
  return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);
}

function lgeMoney(cents) {
  if (!Number.isFinite(cents) || cents <= 0) return 'REQUEST PRICE';
  return new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: 'USD', minimumFractionDigits: 2
  }).format(cents / 100);
}

function lgeProductCard(product, rootUrl, fallbackType) {
  const [handle, title, type, image, price, compareAt, available] = product;
  const safeTitle = lgeEscapeHtml(title);
  const productUrl = `${rootUrl}products/${encodeURIComponent(handle)}`;
  const safeImage = /^https:\/\/cdn\.shopify\.com\//i.test(image || '') ? lgeEscapeHtml(image) : '';
  const compare = Number(compareAt) > Number(price) ? `<s>${lgeMoney(Number(compareAt))}</s>` : '';
  const visual = safeImage
    ? `<img src="${safeImage}" loading="lazy" alt="${safeTitle}">`
    : '<span class="lge-product-placeholder">LIKEGOEASY</span>';
  return `<article class="product-card">
    <a class="product-image" href="${lgeEscapeHtml(productUrl)}">
      <span class="product-tag">${available ? 'AVAILABLE' : 'SOURCE ON REQUEST'}</span>
      ${visual}<span class="product-arrow" aria-hidden="true">↗</span>
    </a>
    <p>${lgeEscapeHtml(type || fallbackType)}</p>
    <h3><a href="${lgeEscapeHtml(productUrl)}">${safeTitle}</a></h3>
    <div class="price">${lgeMoney(Number(price))}${compare}</div>
  </article>`;
}

function initLgeCatalog() {
  const app = document.getElementById('LgeCategoryCatalog');
  if (!app) return;

  const params = new URLSearchParams(window.location.search);
  const categoryHandle = params.get('lge_l1') || '';
  const category = LGE_CATEGORIES[categoryHandle];
  if (!category) {
    document.documentElement.classList.remove('lge-category-mode');
    return;
  }
  document.documentElement.classList.add('lge-category-mode');

  const data = window.LGE_CATALOG_DATA;
  const grid = document.getElementById('LgeProductGrid');
  if (!Array.isArray(data)) {
    grid.innerHTML = '<p class="lge-catalog-error">The product catalogue could not be loaded. Please refresh this page.</p>';
    return;
  }

  const requestedSubcategory = params.get('lge_l2') || '';
  const subcategory = category.subcategories.find(([handle]) => handle === requestedSubcategory);
  const subcategoryHandle = subcategory ? subcategory[0] : '';
  const displayTitle = subcategory ? subcategory[1] : category.title;
  const rootUrl = (app.dataset.rootUrl || '/').replace(/\/?$/, '/');
  const collectionUrl = app.dataset.collectionUrl || `${rootUrl}collections/all`;
  const pageSize = Math.max(12, Number.parseInt(app.dataset.pageSize || '24', 10));

  let products = data.filter((product) => product[7] === categoryHandle && (!subcategoryHandle || product[8] === subcategoryHandle));
  const sortValue = params.get('lge_sort') || 'featured';
  document.getElementById('LgeCatalogSort').value = sortValue;
  if (sortValue === 'title-ascending') products.sort((a, b) => a[1].localeCompare(b[1]));
  if (sortValue === 'title-descending') products.sort((a, b) => b[1].localeCompare(a[1]));
  if (sortValue === 'price-ascending') products.sort((a, b) => a[4] - b[4]);
  if (sortValue === 'price-descending') products.sort((a, b) => b[4] - a[4]);

  const pageCount = Math.max(1, Math.ceil(products.length / pageSize));
  const requestedPage = Number.parseInt(params.get('lge_page') || '1', 10);
  const currentPage = Math.min(pageCount, Math.max(1, Number.isFinite(requestedPage) ? requestedPage : 1));
  const visibleProducts = products.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const hero = document.getElementById('LgeCategoryHero');
  hero.className = `collection-page-hero collection-theme-${categoryHandle}`;
  document.getElementById('LgeProfileNumber').textContent = `PRODUCT FAMILY / ${category.number}`;
  document.getElementById('LgeProfileEyebrow').textContent = category.eyebrow;
  document.getElementById('LgeProfileHeadline').textContent = subcategory ? displayTitle : category.headline;
  document.getElementById('LgeProfileIntro').textContent = category.intro;
  document.getElementById('LgeDisplayTitle').textContent = displayTitle;
  document.getElementById('LgeHeroCount').textContent = String(products.length);
  document.getElementById('LgeProductCount').textContent = `${products.length} PRODUCTS`;
  document.getElementById('LgeProductsHeading').textContent = `All ${displayTitle}`;
  document.getElementById('LgeAssuranceOne')?.replaceChildren(category.assurance[0]);
  document.getElementById('LgeAssuranceTwo')?.replaceChildren(category.assurance[1]);
  document.getElementById('LgeAssuranceThree')?.replaceChildren(category.assurance[2]);
  document.title = `${displayTitle} – LikeGoEasy`;

  const subcategorySection = document.getElementById('LgeSubcategorySection');
  if (subcategory) {
    subcategorySection.hidden = true;
  } else {
    subcategorySection.hidden = false;
    document.getElementById('LgeSubcategoryHeading').textContent = `Explore ${category.title}`;
    document.getElementById('LgeSubcategoryGrid').innerHTML = category.subcategories.map(([handle, label], index) => {
      const href = `${collectionUrl}?lge_l1=${encodeURIComponent(categoryHandle)}&lge_l2=${encodeURIComponent(handle)}`;
      const number = String(index + 1).padStart(2, '0');
      return `<a class="subcategory-card" href="${lgeEscapeHtml(href)}"><span>${number}</span><strong>${lgeEscapeHtml(label)}</strong><em>VIEW PRODUCTS ↗</em></a>`;
    }).join('');
  }

  grid.innerHTML = visibleProducts.length
    ? visibleProducts.map((product) => lgeProductCard(product, rootUrl, displayTitle)).join('')
    : '<p class="empty-state">No products found in this category.</p>';

  const pageUrl = (page) => {
    const url = new URL(window.location.href);
    url.searchParams.set('lge_page', String(page));
    return `${url.pathname}${url.search}`;
  };
  const pagination = document.getElementById('LgeCatalogPagination');
  if (pageCount <= 1) {
    pagination.hidden = true;
    pagination.innerHTML = '';
  } else {
    pagination.hidden = false;
    const previous = currentPage > 1 ? `<a href="${lgeEscapeHtml(pageUrl(currentPage - 1))}">← PREVIOUS</a>` : '<i></i>';
    const next = currentPage < pageCount ? `<a href="${lgeEscapeHtml(pageUrl(currentPage + 1))}">NEXT →</a>` : '<i></i>';
    pagination.innerHTML = `${previous}<span>PAGE ${currentPage} / ${pageCount}</span>${next}`;
  }

  const sortForm = document.getElementById('LgeCatalogSortForm');
  sortForm.addEventListener('submit', (event) => event.preventDefault());
  document.getElementById('LgeCatalogSort').addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('lge_sort', event.target.value);
    url.searchParams.delete('lge_page');
    window.location.assign(`${url.pathname}${url.search}`);
  });
}

document.addEventListener('DOMContentLoaded', initLgeCatalog);
